import React, { FC } from "react"

interface Props {
    bold: boolean | null
    italic: boolean | null
    underline: boolean | null
    lineThrough: boolean | null
    onChange: (properties: { bold?: boolean; italic?: boolean; underline?: boolean; lineThrough?: boolean }) => void
    prefix: string
}

export const TextFormatPicker: FC<Props> = ({
    bold,
    italic,
    underline,
    lineThrough,
    onChange,
    prefix,
}) => {
    const changeProperty = (event: React.MouseEvent<HTMLButtonElement>,
                            changes: { bold?: boolean; italic?: boolean; underline?: boolean; lineThrough?: boolean }) => {
        event.preventDefault()
        event.stopPropagation()
        onChange(changes)
    }

    return (
        <div className={`${prefix}__format`}>
            <button
                className={`${prefix}__button ${bold ? `${prefix}__button--active` : ""}`}
                onMouseDown={event => changeProperty(event, { bold: !bold })}
                aria-label="Bold"
                type="button"
            >
                <strong>B</strong>
            </button>
            <button
                className={`${prefix}__button ${prefix}__button--italic ${italic ? `${prefix}__button--active` : ""}`}
                onMouseDown={event => changeProperty(event, { italic: !italic })}
                aria-label="Italic"
                type="button"
            >
                I
            </button>
            <button
                className={`${prefix}__button ${underline ? `${prefix}__button--active` : ""}`}
                onMouseDown={event => changeProperty(event, { underline: !underline })}
                aria-label="Underline"
                type="button"
            >
                <u>U</u>
            </button>
            <button
                className={`${prefix}__button ${lineThrough ? `${prefix}__button--active` : ""}`}
                onMouseDown={event => changeProperty(event, { lineThrough: !lineThrough })}
                aria-label="Strikethrough"
                type="button"
            >
                <s>S</s>
            </button>
        </div>
    )
}
